import { campaignModalPageActions } from './Actions';
import { Dispatch } from '../../../components-dummy/types';
import { CampaignStrategy } from '../types/campaign-strategy';
import { WidgetMaker } from '../types/widget-maker';

interface Props {
  isPreview: boolean;
  setIsPreview: (isPreview: boolean) => void;
  dispatch: Dispatch;
  shopId: number;
  strategy: CampaignStrategy;
  collectionId: string;
  widgetMaker: Partial<WidgetMaker>;
  isMobile: boolean;
  setTemplateData: (templateData?: string) => void;
  sku?: string;
}

export const fetchTemplate = async ({
  isPreview,
  setIsPreview,
  dispatch,
  shopId,
  strategy,
  collectionId,
  widgetMaker,
  isMobile,
  setTemplateData,
  sku,
}: Props) => {
  try {
    setIsPreview(isPreview);

    const result = await (
      dispatch(
        campaignModalPageActions.getTemplate({
          shopId,
          strategy,
          collectionId,
          widgetMaker,
          isMobile,
          isPreview,
          sku,
        })
      ) as any
    ).unwrap();

    setTemplateData(result);
  } catch (error) {
    console.error(error);
  }
};
